import React from 'react';

const FillInTheBlank = ({
  contentHTML = '',
  value = [],
  onChange,
  className = '',
  readOnly,
}) => {
  const parts = contentHTML.includes('<input')
    ? contentHTML.split(/(<input[^>]*>)/g)
    : [];

  let inputIndex = 0;

  if (parts.length === 0) {
    return (
      <span className="text-danger">
        Something went wrong with the question
      </span>
    );
  }

  return (
    <div className={className}>
      {parts.map((part, index) => {
        if (part.startsWith('<input')) {
          const currentIndex = inputIndex++;

          return (
            <input
              key={`input-${index}`}
              type="text"
              className="blank-input mx-1"
              value={value[currentIndex] || ''}
              readOnly={readOnly}
              onChange={(e) => {
                if (readOnly) return;
                const newValues = [...value];
                newValues[currentIndex] = e.target.value;
                onChange(newValues);
              }}
            />
          );
        }
        return <span key={index} dangerouslySetInnerHTML={{ __html: part }} />;
      })}
    </div>
  );
};

export default FillInTheBlank;
